import React, { useState, useEffect } from 'react'
import { Autocomplete, Box, Button, Divider, TextField, Modal } from '@mui/material'
import { RootState } from '../../reducers'
import { useDispatch, useSelector } from 'react-redux'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import { Check as CheckIcon, Clear as ClearIcon } from '@mui/icons-material'
import DialogTitle from '@mui/material/DialogTitle'
import { useStyles } from './SettingsStyles'
import { AddITAdminSettings } from '../../actions/api/fetchITAdmin'
import { getITAdminStateData } from '../../actions'
import SuccessSnackBar from '../HOC/SuccesSnackBar'
import ErrorSnackBar from '../HOC/ErrorSnackBar'
import { DialogContentText } from '@mui/material'
import { AddITAdminStateData } from '../../actions/api/fetchITAdmin'

export default function AddStateCodeDialog({ open, handleClose }) {
  const dispatch = useDispatch()
  const classes = useStyles()

  const [StateCode, setStateCode] = useState('')
  const [StateName, setStateName] = useState('')

  const [openSuccessSnackBar, setOpenSuccessSnackBar] = useState(false)
  const [stateCodeChanged, setstateCodeChanged] = useState(false)
  const [stateNameChanged, setstateNameChanged] = useState(false)
  const [openDialog, setOpenDialog] = React.useState(false)
  const [disableSubmit, setDisableSubmit] = useState(true)
  const getClassNames = () => (disableSubmit ? `${classes.disableBtn} ` : `${classes.btn}`)

  const { add_state_success, add_state_error } = useSelector((state: RootState) => state.addStateResponse)

  const handleCloseDialog = (type) => {
    if (type === 'confirm') {
      setStateCode('')
      setStateName('')
    }
    setOpenDialog(false)
  }
  const onCancel = (e) => {
    if (stateCodeChanged || stateNameChanged) {
      setOpenDialog(true)
    } else {
      handleClose()
    }
  }

  const onChangeData = (e, type) => {
    if (type === 'stateCode') {
      setStateCode(e.target.value)
      setstateCodeChanged(true)
    } else if (type === 'stateName') {
      setStateName(e.target.value)
      setstateNameChanged(true)
    }
  }

  useEffect(() => {
    if (StateCode && StateName && StateCode !== '' && StateName !== '') {
      setDisableSubmit(false)
    } else {
      setDisableSubmit(true)
    }
  }, [StateCode, StateName])

  const handleSubmit = async () => {
    const EditParameters = {
      state_name: StateName,
      state_code: StateCode.toUpperCase(),
    }
    await dispatch(AddITAdminStateData({ payload: EditParameters }))
    await setOpenSuccessSnackBar(true)
    await updateDataTable()
  }

  const updateDataTable = () => {
    dispatch(getITAdminStateData())
    setTimeout(closeModal, 100)
    setTimeout(() => setOpenSuccessSnackBar(false), 4000)
    setStateCode('')
    setStateName('')
  }

  const closeModal = handleClose
  const SuccessMessage = `State added successfully`
  const ErrorMessage = `Add State  operation failed`
  return (
    <React.Fragment>
      <div>
        <Dialog
          open={openDialog}
          onClose={handleCloseDialog}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          classes={{ paper: classes.discardDialogHeight }}
        >
          <DialogTitle className={classes.dialogTitle}>Discard Changes</DialogTitle>
          <DialogContent className={classes.discardDialogContent}>
            <DialogContentText id="alert-dialog-description">
              You have pending unsaved changes. Do you really want to discard them?
            </DialogContentText>
          </DialogContent>

          <DialogActions className={classes.buttonActions}>
            <Button
              className={`${classes.btn} ${classes.buttonMargin}`}
              onClick={function (event) {
                handleCloseDialog('confirm')
                handleClose()
              }}
              autoFocus
              endIcon={<CheckIcon />}
            >
              Confirm
            </Button>
            <Button
              className={`${classes.buttonMargin}`}
              onClick={function (event) {
                handleCloseDialog('cancel')
              }}
              variant="outlined"
              endIcon={<ClearIcon />}
            >
              Cancel
            </Button>
          </DialogActions>
        </Dialog>
      </div>
      <div>
        {add_state_success && openSuccessSnackBar && <SuccessSnackBar message={SuccessMessage} />}
        {add_state_error && openSuccessSnackBar && <ErrorSnackBar message={ErrorMessage} />}
        <Modal
          open={open}
          onClose={handleClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box className={`${classes.mt} , ${classes.mb}`}>
            <Dialog
              fullWidth
              maxWidth="sm"
              id="hello"
              classes={{ paper: classes.dialogHeight }}
              open={open}
              onClose={handleClose}
            >
              <DialogTitle className={classes.dialogTitle}>Add State</DialogTitle>
              <Divider />
              <DialogContent>
                <Box component="form" autoComplete="off">
                  <div className={classes.TextField}>
                    <TextField
                      className={classes.TextBox}
                      label="State Code*"
                      type="string"
                      variant="outlined"
                      placeholder="max four characters"
                      inputProps={{
                        style: {
                          padding: 10,
                        },
                        min: 1,
                        maxLength: 4,
                      }}
                      onKeyPress={(e) => {
                        if (!/[a-z.]/i.test(e.key)) {
                          e.preventDefault()
                        }
                      }}
                      onChange={(event) => onChangeData(event, 'stateCode')}
                      defaultValue={''}
                      InputLabelProps={{ shrink: true }}
                    />
                    <TextField
                      className={classes.TextBox}
                      label="State Name*"
                      type="string"
                      variant="outlined"
                      inputProps={{
                        style: {
                          padding: 10,
                        },
                        min: 1,
                      }}
                      onKeyPress={(e) => {
                        if (!/[a-z]*\s*[a-z]*/gi.test(e.key)) {
                          e.preventDefault()
                        }
                      }}
                      onChange={(event) => onChangeData(event, 'stateName')}
                      defaultValue={''}
                      InputLabelProps={{ shrink: true }}
                    />
                  </div>
                </Box>
              </DialogContent>
              <DialogActions className={classes.buttonActions}>
                <Button onClick={handleSubmit} className={getClassNames()} endIcon={<CheckIcon />}>
                  Submit
                </Button>
                <Button
                  onClick={onCancel}
                  color="primary"
                  variant="outlined"
                  style={{ width: '115px' }}
                  endIcon={<ClearIcon />}
                >
                  Close
                </Button>
              </DialogActions>
            </Dialog>
          </Box>
        </Modal>
      </div>
    </React.Fragment>
  )
}
